import { useQuery } from '@tanstack/react-query';

import { SearchParams } from '@/entities/SearchParams';
import { getTeamPlayers } from '@/infrastructure/network/data/team/team-players';
import { useOrganizationStore } from '@/store/organization-store';

export const useTeamLeagueTeamPlayersQuery = (teamUuid: string, searchParams?: SearchParams) => {
	const store = useOrganizationStore();
	return useQuery({
		queryKey: ['TEAM_LEAGUE_TEAM_PLAYERS', store.organizationUuid, store.teamLeagueUuid, teamUuid],
		queryFn: () => getTeamPlayers({ organizationUuid: store.organizationUuid, teamLeagueUuid: store.teamLeagueUuid, teamUuid, searchParams }),
		enabled: !!(store.organizationUuid && store.teamLeagueUuid && teamUuid)
	});
};
